import type React from 'react';

import Autocomplete, { useAutocomplete } from '../../../../common/components/Autocomplete';
import { AutocompleteButton } from '../../../../common/components/Autocomplete/Autocomplete';
import { useProductSearchStateContext } from '../../../../search/hooks/useProductSearchStateContext';
import styles from './SearchOverlayActions.module.scss';

const SearchOverlayActions = (props: {
    children: (hasDifferentQueriesUsed: boolean, queryUsed: string) => React.ReactNode;
    onHintClick?: (hint: string) => void;
}) => {
    const { setQuery, setSearchType, result, autocompleteResult, query, queryUsed } =
        useProductSearchStateContext();

    const { autocompleteQuery, hints: autocompleteHints } = useAutocomplete(
        query,
        autocompleteResult,
        result?.queryUsed,
    );

    const hasAutoCompleteHints = !!autocompleteHints?.length;
    const hasDifferentQueriesUsed = !!queryUsed && queryUsed !== result?.query;

    return (
        <>
            {props.children(hasDifferentQueriesUsed, queryUsed!)}
            {hasAutoCompleteHints && (
                <Autocomplete
                    query={autocompleteQuery}
                    hints={autocompleteHints}
                    label="Prova istället"
                    renderHint={(hint) => (
                        <AutocompleteButton
                            onClick={() => {
                                setQuery(hint);
                                setSearchType('direct');
                                props.onHintClick?.(hint);
                            }}
                        >
                            {hint}
                        </AutocompleteButton>
                    )}
                    className={styles.Autocomplete}
                />
            )}
        </>
    );
};

export default SearchOverlayActions;
